module.exports = __webpack_public_path__ + "assets/img/saules-energija-namui.a063422e.jpg";